var BulkActions = function () {
    var self = this;

    this.runAction = function (href, confirm, confirmTitle, confirmText, ajax) {
        //Close the dropdown bulk action
        $(".dropdown-menu").parent("div.btn-group").removeClass('open');

        if (confirm) {
            swal({
                animation: false,
                customClass: 'animated fadeIn',
                title: confirmTitle,
                text: confirmText,
                allowOutsideClick: true,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#D2282D',
                cancelButtonText: 'Annuler',
                confirmButtonText: 'Oui !',
                showLoaderOnConfirm: true,
                preConfirm: function() {
                    return new Promise(function (resolve) {
                        let onResetPassword = function() {
                            swal({
                                animation: false,
                                customClass: 'animated fadeIn',
                                title: 'Succès',
                                allowOutsideClick: true,
                                html: 'Envoi du nouveau mot de passe effectué avec succès',
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonColor: "green",
                                confirmButtonText: "Ok"
                            });
                        }
                        let callbackComplete = href.includes("force-reset-password") ? onResetPassword : resolve;
                        self.executeRequest(href, ajax, undefined, undefined, callbackComplete);
                    });
                }
            }).then((result) => {
                swal.close();
            });
        }
        else {
            self.executeRequest(href, ajax);
        }
    };

    this.executeRequest = function (href, ajax, callbackSuccess, callbackError, callbackComplete) {
        var ids = [];

        //if the users want to select all item on all pages
        if (window.AppDatatable.SelectAll) {

            //reinit variable
            window.AppDatatable.SelectAll = false;

            var filterLocal = [];
            var tableLocal = window.AppDatatable.$table.DataTable();

            window.AppDatatable.$table.find('.form-filter').each(function () {
                var colIdx = $(this).parents("th").attr('data-field-key');

                var value = tableLocal
                    .column(colIdx)
                    .search();

                var key = $(this).attr('name');

                try {
                    var localValue = JSON.parse(value);

                    if(typeof localValue == "object"){
                        value = localValue[key];
                    }
                } catch (e) {
                    console.log('Erreur récupération filtres');
                }

                // On récupère tous les filtres de la datatable et leur valeur associée
                filterLocal.push([key,value]);
            });

            parent_dir = window.location.href;
            parent_dir = parent_dir.endsWith("#") ? parent_dir.substring(parent_dir.length - 1, 0) : parent_dir;

            if(filterLocal.length > 0){
                parent_dir += "?";

                // On ajoute les filtres trouvés pour qu'ils soient utilisés dans la requête de select de masse
                filterLocal.forEach((item)=> {
                    if(item[1] !== ""){
                        parent_dir += '&'+item[0]+'='+item[1];
                    }
                });
            }

            $.ajax({
                url: parent_dir,
                success: function (data) {
                    // get all ids from the entity
                    for( var i = 0 ; i < data.length ; i++){
                        // if the user select all items and then unchecked somes checkboxs we remove the item unselected
                        if( ! window.AppDatatable.SelectAll_expection.includes(data[i].toString())){
                            ids.push(data[i]);
                        }
                    }

                    if(ajax)
                    {
                        ajaxRequest(ids, ajax, href, callbackComplete);
                    }else{
                        makeFormRedirect(ids, href);
                    }
                }
            });
        }else{
            $checkedRows = $('input[name="select-row"]:checked');

            if (!$checkedRows.length) {
                swal({
                    animation: false,
                    customClass: 'animated fadeIn',
                    title: 'Attention !',
                    allowOutsideClick: true,
                    html: 'Vous devez sélectionner au moins un élément pour lancer l\'action.',
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: "#D2282D",
                    confirmButtonText: "Ok"
                });

                return false;
            }

            $checkedRows.each(function () {
                ids.push($(this).val());
            });

            if(ajax)
            {
                ajaxRequest(ids, ajax, href, callbackComplete);
            }else{
                makeFormRedirect(ids, href);
            }
        }

        function makeFormRedirect(ids, href){

            var csrf_token = $('meta[name="csrf-token"]').attr('content');

            $('body').append(function () {

                var str = "<form name='form-bulk-to-submit' action='" + href + "' method='POST' style='display:none;'>\n" +
                    "<input type='hidden' name='_token' value='" + csrf_token + "' />" ;

                ids.forEach(item => {
                    str += "<input type='hidden' name='ids[]' value='" + item + "' />";
                });

                str += "</form>";
                return str;
            });

            $('form[name="form-bulk-to-submit"]').submit();
        }

        function ajaxRequest(ids, ajax, href, callbackComplete) {
            var export_excel = false;

            if (href.includes('export/excel')){
                export_excel = true;
            }

            $.ajax({
                url: href,
                method: "POST",
                data: {ids: [...new Set(ids)]}, // "Set" pour éviter les doublons
                xhrFields: {
                    responseType: export_excel ? 'blob' : 'json'
                },
                success: function (data) {
                    if (export_excel && data){
                        self.downloadFile(data);
                    }

                    toastr.success('Action effectuée avec succès');
                },
                error: function () {
                    toastr.error('Une erreur s\'est produite');
                },
                complete: function () {
                    window.AppDatatable.table.ajax.reload();

                    //Unchecked all checkboxs
                    $("#app-datatable input[type='checkbox']").prop('checked', false);
                    $('#globalSelection').remove();

                    if(callbackComplete !== undefined){
                        callbackComplete();
                    }
                }
            });
        }
    };

    this.downloadFile = function(data) {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(data);

        a.href = url;
        a.download = 'export.xlsx';

        document.body.append(a);

        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
    };

    this.initEvents = function () {
        $('.bulkAction').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            self.runAction(
                $(this).attr('href'),
                $(this).data('confirm'),
                $(this).data('confirm-title') ? $(this).data('confirm-title') : 'Êtes-vous sûr ?',
                $(this).data('confirm-text'),
                $(this).data('ajax')
            );

            // Reset Datatable after Export Excel
            var url = $(this).attr('href');

            if (url.includes('export/excel')){
                $("#app-datatable input[type='checkbox']").prop('checked', false);
                $('#globalSelection').remove();
            }
        });
    };

    return {
        init: function () {
            self.initEvents();

            return self;
        }
    };
}();

(function ($) {
    BulkActions.init();
})(jQuery);